import { SendOutlined } from '@ant-design/icons'
import { TranslatedMessage } from '@library/react-toolkit'
import { Alert, Button, Modal } from 'antd'
import { array, boolean, record, string } from 'fp-ts'
import { pipe } from 'fp-ts/lib/function'
import * as React from 'react'
import { useIntl } from 'react-intl'
import {
  useMode,
  usePublishInvoices,
  useSelectedBills,
  useSmartHubInvoices,
} from './queries'

const ExportButton = () => {
  const mode = useMode()
  const selectedBills = useSelectedBills()
  const noSelection = record.isEmpty(selectedBills)
  const smartHubInvoices = useSmartHubInvoices(
    pipe(
      selectedBills,
      record.collect(string.Ord)((_, b) => b)
    )
  )
  const intl = useIntl()
  const publishInvoices = usePublishInvoices()
  const anyLoading = pipe(
    smartHubInvoices,
    array.foldMap(boolean.MonoidAny)(q => q.isLoading)
  )
  const anyPublished = pipe(
    smartHubInvoices,
    array.foldMap(boolean.MonoidAny)(q => !!q.data && q.data !== 'Not Found')
  )

  const showConfirm = React.useCallback(() => {
    Modal.confirm({
      title: intl.formatMessage({ id: 'publishConfirmPrompt' }),
      content: intl.formatMessage(
        { id: 'publishMessageConfirmPrompt' },
        {
          b: (...chunks) => <b>{chunks}</b>,

          br: <br />,
        }
      ),
      okText: intl.formatMessage({ id: 'confirm' }),
      cancelText: intl.formatMessage({ id: 'cancel' }),
      onOk: () => {
        pipe(
          selectedBills,
          // TODO: fixme
          // @ts-ignore
          record.collect(string.Ord)((_, b) => ({
            id: b.id,
            amount: b.amount,
            payer: b.customer?.name ?? b.supplier,
            reference: b.reference,
            asset: b.unitID,
          })),
          publishInvoices.mutate
        )
      },
    })
  }, [selectedBills])

  return mode === 'organization' ? (
    <div>
      <Button
        icon={<SendOutlined />}
        disabled={noSelection || anyPublished}
        onClick={() => showConfirm()}
        loading={anyLoading}
      >
        <TranslatedMessage id="publishInvoice" />
      </Button>
      {anyPublished && (
        <Alert
          type="error"
          message={<TranslatedMessage id="cannotPublishPublishedInvoices" />}
          style={{ marginTop: '8px' }}
        />
      )}
    </div>
  ) : null
}

export default ExportButton
